import React, { useState, useEffect } from "react";
import { Select, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import { useParams } from "react-router-dom";
import { environment, apiRoutes } from "../../auth/apiRoute";
const { Option } = Select;

let timeout;
let currentValue;
function fetch(value, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  function fake() {
    axios
      .post(apiRoutes[environment].searchUser + `?searchQuery=${value}`)
      .then((response) => {
        var result = response.data;
        var resultData = [];

        resultData = result.map((item) => {
          return { ...item, ...{ key: item._id } };
        });
        console.log(resultData);
        callback(resultData);
      })
      .catch((error) => {
        console.log(error);
      });
    // const str = qs.stringify({
    //   code: "utf-8",
    //   q: value,
    // });
    // jsonp(apiRoutes[environment].searchUser + `/${str}`)
    //   .then((response) => response.json())
    //   .then((d) => {
    //     console.log(d);
    //     if (currentValue === value) {
    //       const { result } = d;
    //       const data = [];
    //       result.forEach((r) => {
    //         data.push({
    //           value: r[0],
    //           text: r[0],
    //         });
    //       });
    //       callback(data);
    //     }
    //   });
  }

  timeout = setTimeout(fake, 300);
}
export default function AddStaff(props) {
  let { hotelId } = useParams();
  const [value, setValue] = useState("");
  const [data, setData] = useState([]);
  const [selectedUser, setSelectedUser] = useState({});
  const handleSearch = (value) => {
    if (value) {
      fetch(value, (data) => setData(data));
    } else {
      setData([]);
    }
  };

  const handleChange = (value) => {
    setValue(value);
  };
  const handleSelect = (value, record) => {
    console.log(value, record);
    setSelectedUser(record);
  };

  const onClickAdd = async () => {
    if (selectedUser.value) {
      console.log(selectedUser);

      updateStaff();
      setValue("");
    }
  };

  const updateStaff = async () => {
    var newSelectedUser = selectedUser;
    newSelectedUser.hotelId = hotelId;
    newSelectedUser._id = newSelectedUser.value;

    axios
      .post(apiRoutes[environment].updateStaff, newSelectedUser)
      .then((response) => {
        console.log(response.data);
        props.reloadUser();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const options = data.map((d) => (
    <Option key={d._id}>{d.firstName + " " + d.lastName}</Option>
  ));

  return (
    <div>
      <Select
        showSearch
        value={value}
        placeholder={"Seach..."}
        style={{ width: "200px" }}
        defaultActiveFirstOption={false}
        showArrow={false}
        filterOption={false}
        onSearch={handleSearch}
        onChange={handleChange}
        notFoundContent={null}
        onSelect={handleSelect}
      >
        {options}
      </Select>{" "}
      <Button type="primary" onClick={onClickAdd}>
        Add
      </Button>
    </div>
  );
}
